module.exports = __webpack_public_path__ + "static/media/notiWait.f7098ce3.png";